module.exports = __webpack_public_path__ + "img/express.593b7ab6.svg";